import { useEffect } from 'react';

export default function usePreloadImage(src) {
  useEffect(() => {
    if (!src) return;
    const link = document.createElement('link');
    link.rel = 'preload';
    link.as = 'image';
    link.href = src;
    link.fetchPriority = 'high'; // Chrome 110+, ignored elsewhere
    document.head.appendChild(link);
    return () => document.head.removeChild(link);
  }, [src]);
}
